/**
 * Created by Alican Köker on 2019-01-30.
 */
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {IReelStoppedData} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {SpinReelEvent} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinReelEvent";
import {EdisonHelper} from "../../utils/EdisonHelper";
import {EdisonGameConfig} from "../EdisonGameConfig";
import {EdisonGameModuleConfig} from "../EdisonGameModuleConfig";
import {EdisonSoundConfig} from "../EdisonSoundConfig";
import {EdisonGameMode} from "../gameMode/EdisonGameMode";
import {EdisonParsedGameData} from "../server/data/EdisonParsedGameData";
import {EdisonParsedInitData} from "../server/data/EdisonParsedInitData";

export class EdisonReels extends Reels {

    private _gameData:EdisonParsedGameData;
    private _isRestore:boolean = false;
    private _anticipationStarted:boolean = false;

    constructor() {
        super();
    }

    protected addEventListeners():void {
        super.addEventListeners();
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event:GameEvent) => this.onInitDataParsed(event.params[0]));
        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event:GameEvent) => this.onGameDataParsed(event.params[0]));
    }

    protected onInitDataParsed(data:EdisonParsedInitData):void {
        this._isRestore = data.isRestoreState;
    }

    private onGameDataParsed(data:EdisonParsedGameData):void {
        this._gameData = data;

        if(data.mode === EdisonGameMode.FREESPIN && this._gameData.freespinsLeftBefore > 0 && !this._isRestore) {
            SlotGame.keypad.setZeroBetSpinCounter(this._gameData.freespinsLeftBefore);
        }

        this._isRestore = false;
    }

    private getFirstStackedReel():number {
        for(let i:number = 0; i < EdisonGameConfig.instance.REELS_NUM; i++) {
            if(this._gameData.stackedNearWinReels[i])
                return i - 1;
        }

        return -1;
    }

    protected onReelBounceStarted(stopData:IReelStoppedData):void {
        this._reelsActualSpinningStates[stopData.reelId] = false;
        EdisonHelper.sortSymbolLayerLevels(stopData.reelId);

        if(this._gameData.nearWinBigWinReels[stopData.reelId + 1]) {
            this._anticipationStarted = true;
            SlotGame.sound.playEffect(EdisonSoundConfig.instance.ANTICIPATION);
            SlotGame.sound.fadeAmbience(0, 500);
        }
        if((this._gameData.stackedNearWinReels[stopData.reelId + 1] || this.fSAnticipationToPlay(stopData.reelId)) && !this._anticipationStarted) {
            this._anticipationStarted = true;
            SlotGame.sound.playEffect(EdisonSoundConfig.instance.FS_ANTICIPATION);
            SlotGame.sound.fadeAmbience(0, 500);
        }

        if(stopData.reelId === 4 && this._anticipationStarted) {
            SlotGame.sound.stopEffect(EdisonSoundConfig.instance.FS_ANTICIPATION, 100);
            SlotGame.sound.stopEffect(EdisonSoundConfig.instance.ANTICIPATION, 100);
            SlotGame.sound.fadeAmbience(1, 5000);
            this._anticipationStarted = false;

            if(this._gameData!.nextMode !== EdisonGameMode.STACKED_RESPIN && this._gameData!.nextMode !== EdisonGameMode.FREESPIN) {
                SlotGame.sound.playEffect(EdisonSoundConfig.instance.ANTICIPATION_FAIL);
            }
        }
    }

    protected onReelSpinStopped(reelId:number):void {
        super.onReelSpinStopped(reelId);

        let firstSNWR:number = this.getFirstStackedReel();
        if(reelId === firstSNWR) {
            this._gameData.stackedNearWinReels.forEach((value, index) => {
                if(value)
                    EventHandler.dispatchEvent(new GameEvent(SpinReelEvent.REEL_SET_SPIN_SPEED, {
                        reelId : index,
                        spinSpeed : .04,
                        fadeInTime : .02
                    }));
            });
        }

        if(reelId === 4) {
            EdisonGameModuleConfig.anticipationView.stopAnticipation();
            EdisonGameModuleConfig.winPresentationView.reelsStopped = true;
        }

        if(reelId > 3)
            return;

        if(this._gameData.stackedNearWinReels[reelId + 1]) {
            EdisonGameModuleConfig.anticipationView.playWinAnticipation(reelId + 1);
        }

        const toPlayFsAnticipation:boolean = this.fSAnticipationToPlay(reelId);

        if(toPlayFsAnticipation) {
            EdisonGameModuleConfig.anticipationView.playFreespinAnticipation(reelId + 1);
        }
    }

    private fSAnticipationToPlay(reelId:number):boolean {
        let scatterCount:number = this._gameData!.scatterPositions!.filter(function(elm) {return elm > -1}).length;
        let stackedCount:number = this._gameData!.stackedModeOverlay!.filter(function(elm) {return elm}).length;

        return reelId > 0 && reelId < 4 && this._gameData!.nearWinReels[reelId + 1]
            || (reelId === 3 && scatterCount === 2 && stackedCount === 2 && this._gameData!.nextMode !== EdisonGameMode.STACKED_RESPIN);
    }
}